import { queryKeys } from '@query/keys'
import { useQuery } from '@tanstack/react-query'

import { useAccountReadContext } from '@context/AccountContextContext'

import { useApiClient } from '@utils/ApiClient'
import { ClientApiClient } from '@utils/clientApi'

import { FilterOptionsForIntroducingBrokerRebatePayoutsDto } from '@model/FilterOptionsForIntroducingBrokerRebatePayoutsDto'

export const useIBApprovalsFilterOptions =
  (): FilterOptionsForIntroducingBrokerRebatePayoutsDto => {
    const apiClient = useApiClient(ClientApiClient)
    const { account } = useAccountReadContext()

    const ibId = account?.clientIntroducingBroker?.id

    const { data } = useQuery({
      queryKey: queryKeys.ib.rebates.approvalsFilterOptions(ibId),
      queryFn: () => apiClient.getIBRebatePayoutsFilterOptions(ibId!),
      enabled: !!ibId,
      // staleTime: 5 * 60_000,
    })

    return {
      tradingAccounts: data?.tradingAccounts || [],
      accountTypes: data?.accountTypes || [],
      groups: data?.groups || [],
    }
  }
